import { CatalogRecord } from 'shared';
import { CatalogService } from '../../catalog.service';
import { AnalyticsService } from '../../../../services/analytics.service';
import { debounceTime, tap } from 'rxjs/operators';
import { Component, OnInit, EventEmitter, ViewChild, Input, Output } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';

@Component({
  selector: 'app-catalog-searchbar',
  templateUrl: './catalog-searchbar.component.html',
  styleUrls: ['./catalog-searchbar.component.scss']
})
export class CatalogSearchbarComponent implements OnInit {
  options: CatalogRecord[] = [];
  filteredOptions$: Observable<CatalogRecord[]>;

  cachedRecords = new Map<string, CatalogRecord>();

  @ViewChild('autoInput') input;

  @Input() fieldSize = 'giant';
  @Output() searchTerm = new EventEmitter<string>();
  @Output() searchCatalogRecord = new EventEmitter<CatalogRecord>();

  constructor(private catalogService: CatalogService, private analyticsService: AnalyticsService) {}

  ngOnInit(): void {
    this.filteredOptions$ = of(this.options);
  }

  getFilteredOptions(value: string): Observable<CatalogRecord[]> {
    return this.catalogService.keywordSearch(value, 3).pipe(
      debounceTime(1200),
      tap((records) => {
        records.forEach((record) => {
          this.cachedRecords.set(record.name.toLowerCase(), record);
        });
      })
    );
  }

  onChange(reset = false): void {
    if (reset) {
      this.filteredOptions$ = new Subject();
    } else {
      this.filteredOptions$ = this.getFilteredOptions(this.input.nativeElement.value);
    }
  }

  async onSelectionChange($event: string): Promise<void> {
    if (!$event || $event === '') {
      return;
    }
    $event = $event.toLowerCase();

    if (this.cachedRecords.has($event)) {
      this.searchCatalogRecord.emit(this.cachedRecords.get($event));
    } else {
      this.searchTerm.emit($event);
    }

    if ($event.length > 4) {
      await this.analyticsService.logEvent('wholesale_search_keyword_catalog', {
        wholesaleCatalogSearchTerm: $event.toLowerCase()
      });
    }

    this.onChange(true);
  }
}
